export default __webpack_public_path__ + "static/media/logo_huge.849826dc.png";